import { TextBody, TextTitle } from '@/design-system/components/typography';
import { UploadDocument } from '@/design-system/components/uploadDocument/UploadDocument';
import { SxProp, View } from 'dripsy';
import * as DocumentPicker from 'expo-document-picker';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Platform } from 'react-native';
export interface UploadComponentProps {
  sx?: SxProp;
  documentCallback: (file: DocumentPicker.DocumentResult) => void;
}

export const UploadMobileComponent: React.FC<UploadComponentProps> = ({ sx, documentCallback }) => {
  const { t } = useTranslation('global-bill-payment');

  const documentSelected = async (document: undefined | DocumentPicker.DocumentResult) => {
    if (!!document && document.type === 'success' && !!document.file) {
      documentCallback(document);
    }
  };

  return (
    <View sx={{ ...sxStyles.container, ...sx }}>
      <View sx={sxStyles.titleLayout}>
        <View sx={sxStyles.number}>
          <TextBody sx={sxStyles.textNumber}>1</TextBody>
        </View>
        <TextTitle semiBold={true} sx={sxStyles.textNote}>
          {t('global-bill-payment::instruction.text--please-upload')}
        </TextTitle>
      </View>

      <View sx={sxStyles.rightComponent}>
        <UploadDocument
          title={t('global-bill-payment::glossary.tap-to-upload')}
          instructions={t('global-bill-payment::instruction.text--intro-before-upload')}
          successUploadedInstructions={t('global-bill-payment::instruction.text--intro-after-upload')}
          onValueChange={documentSelected}
          sx={sxStyles.uploadDocument}
          isLoading={false}
          isUploadSuccess={true}
          type={['image/png', 'image/jpeg', 'application/pdf']}
        />
      </View>
    </View>
  );
};

const sxStyles: Record<string, SxProp> = {
  container: {
    backgroundColor: 'transparent',
    flexDirection: 'column',
    width: '100%'
  },
  titleLayout: {
    pl: '$8',
    flexDirection: 'column'
  },
  rightComponent: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    mt: '$5'
  },
  number: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '$6',
    height: '$6',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '$secondary',
    borderRadius: '$radius8'
  },
  textNumber: {
    pt: Platform.OS != 'web' ? 2 : '$0',
    color: '$white'
  },
  textNote: {
    pt: '$1'
  },
  uploadDocument: {
    width: '100%',
    height: '100%'
  }
};
